export default __webpack_public_path__ + "static/media/133.ec267f7e.jpg";